import React, { useContext } from "react";
import { Box, Typography, Paper, makeStyles, Grid } from "@material-ui/core";
import { ViewWinnerContext } from "../../../contexts/ViewWinnerContext";
import { getLang } from "app/feature/constants";

const useStyles = makeStyles((theme) => ({
  metricsContainer: {
    marginBottom: theme.spacing(3),
  },
  metricCard: {
    padding: theme.spacing(2, 3),
    borderRadius: theme.spacing(1),
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    height: "100%",
  },
  metricLabel: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  metricValue: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: theme.palette.text.primary,
  },
  metricValueRed: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#E21B1B",
  },
  metricValueGreen: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#6AAF68",
  },
  metricValueRejected: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#D32F2F",
  },
}));

export default function ViewWinnerMetricsPanelComponent() {
  const classes = useStyles();
  const { metrics, lang } = useContext(ViewWinnerContext);

  const metricsData = [
    {
      label: getLang(lang, "label.CLAIMED_PRIZE"),
      value: metrics.claimed,
      colorClass: classes.metricValue,
    },
    {
      label: getLang(lang, "label.UNCLAIMED_PRIZE"),
      value: metrics.unclaimed,
      colorClass: classes.metricValue,
    },
    {
      label: getLang(lang, "label.UNPROCESSED"),
      value: metrics.unprocessed,
      colorClass: classes.metricValueRed,
    },
    {
      label: getLang(lang, "label.PROCESSED"),
      value: metrics.processed,
      colorClass: classes.metricValueGreen,
    },
    {
      label: getLang(lang, "label.REJECTED"),
      value: metrics.rejected,
      colorClass: classes.metricValueRejected,
    },
  ];

  return (
    <Box className={classes.metricsContainer}>
      <Typography
        variant="h6"
        style={{ fontWeight: "bold", marginBottom: 16 }}
      >
        {getLang(lang, "label.KEY_METRICS")}
      </Typography>
      <Grid container spacing={2}>
        {metricsData.map((metric, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Paper className={classes.metricCard}>
              <Typography className={classes.metricLabel}>
                {metric.label}
              </Typography>
              <Typography className={metric.colorClass}>
                {metric.value.toLocaleString("en-US")}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
